import { useMemo } from 'react';
import { useGeoOverride } from '@/hooks/useGeoOverride';

interface PriceTier {
  monthly: string;
  annual: string;
}

interface ServicePrices {
  mentorship: string;
  aiResearchConsultation: string;
  aiFinancialResearch: string;
  ideaToLaunch: string;
  agenticResearchSystems: string;
}

interface GeoCurrency {
  isIndian: boolean;
  currency: 'INR' | 'USD';
  symbol: string;
  prices: {
    free: string;
    pro: string;
    proMax: string;
  };
  subscriptionPrices: {
    base: PriceTier;
    premium: PriceTier;
    /** @deprecated Use base or premium instead */
    monthly: string;
    /** @deprecated Use base or premium instead */
    annual: string;
  };
  servicePrices: ServicePrices;
  contactEmail: string;
  freeLabel: string;
}

export function useGeoCurrency(): GeoCurrency {
  const { geoMode } = useGeoOverride();

  return useMemo(() => {
    let isIndian: boolean;
    if (geoMode === 'india') {
      isIndian = true;
    } else if (geoMode === 'international') {
      isIndian = false;
    } else {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      isIndian = timezone === 'Asia/Kolkata' || timezone === 'Asia/Calcutta';
    }
    const contactEmail = 'info@shikshannivesh.com';

    if (isIndian) {
      return {
        isIndian,
        currency: 'INR' as const,
        symbol: '₹',
        prices: {
          free: '₹0',
          pro: '₹299',
          proMax: '₹999',
        },
        subscriptionPrices: {
          base: {
            monthly: '₹999',
            annual: '₹9,999',
          },
          premium: {
            monthly: '₹999',
            annual: '₹9,999',
          },
          monthly: '₹999',
          annual: '₹9,999',
        },
        servicePrices: {
          mentorship: '₹3,00,000',
          aiResearchConsultation: 'Starts from ₹19,999',
          aiFinancialResearch: '₹10,000',
          ideaToLaunch: 'Starting from ₹49,999',
          agenticResearchSystems: '₹1,00,000',
        },
        contactEmail,
        freeLabel: '₹0 forever',
      };
    }

    return {
      isIndian,
      currency: 'USD' as const,
      symbol: '$',
      prices: {
        free: '$0',
        pro: '$11',
        proMax: '$21',
      },
      subscriptionPrices: {
        base: {
          monthly: '$39',
          annual: '$399',
        },
        premium: {
          monthly: '$39',
          annual: '$399',
        },
        monthly: '$39',
        annual: '$399',
      },
      servicePrices: {
        mentorship: '$5,000',
        aiResearchConsultation: 'Starts from $499',
        aiFinancialResearch: '$199',
        ideaToLaunch: 'Starting from $999',
        agenticResearchSystems: '$3,000',
      },
      contactEmail,
      freeLabel: '$0 forever',
    };
  }, [geoMode]);
}
